import { render, staticRenderFns } from "./permohonan-sponsorship.vue?vue&type=template&id=c771b3e2&"
import script from "./permohonan-sponsorship.vue?vue&type=script&lang=js&"
export * from "./permohonan-sponsorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports